// extracted by mini-css-extract-plugin
module.exports = {"list":"ScenarioBid_list__2VV8m","button":"ScenarioBid_button__2c3QN"};